import { Vue, Component } from 'vue-property-decorator';

interface SMSConfirmOptions {
  name?: string;
}

@Component
export default class ProgressSmsAlertMixin extends Vue {
  smsAlertBeforeSendSingle(
    callbackOk: (value: boolean | null, userId?: number) => void,
    callbackCancel?: (value: boolean | null, userId?: number) => void,
    userId?: number,
    options?: SMSConfirmOptions,
  ) {
    this.$bvModal.msgBoxConfirm(`您將發送簡訊給${options?.name}。`, {
      title: '建案進度管理',
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'primary',
      cancelVariant: 'outline-danger',
      okTitle: '確認發送',
      cancelTitle: '取消',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true,
    })
      .then((value) => {
        if (value === true) {
          if (callbackOk) {
            callbackOk(value, userId);
          }
        } else if (value === false) {
          if (callbackCancel) {
            callbackCancel(value, userId);
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  smsAlertBeforeSendGroup(
    callbackOk: (value: boolean | null, progressId?: number) => void,
    callbackCancel?: (value: boolean | null, progressId?: number) => void,
    progressId?: number,
  ) {
    this.$bvModal.msgBoxConfirm('您即將對多名住戶發送簡訊，簡訊僅發送仍未收到簡訊的住戶，已發送過簡訊的住戶將不會再次發送。', {
      title: '建案進度管理',
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'primary',
      cancelVariant: 'outline-danger',
      okTitle: '確認發送',
      cancelTitle: '取消',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true,
    })
      .then((value) => {
        if (value === true) {
          if (callbackOk) {
            callbackOk(value, progressId);
          }
        } else if (value === false) {
          if (callbackCancel) {
            callbackCancel(value, progressId);
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  smsAlertAfterSent() {
    this.$bvModal.msgBoxOk('簡訊已開始發送。同時提醒您，建議五分鐘至十分鐘內請勿重新發送簡訊。', {
      title: '建案進度管理',
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'success',
      okTitle: '知道了',
      headerClass: 'p-2 border-bottom-0',
      footerClass: 'p-2 border-top-0',
      centered: true,
    });
  }
}
